module.exports = __webpack_public_path__ + "img/wifi-block-logo.e47c80a7.svg";